import Layout from '@components/Layout';
import Login from '@containers/Login';
import { middlewareLogin } from '@helpers/middleware';
import { ITitle } from '@interfaces/ITitle';
import type { NextPage, NextPageContext } from 'next';

const LoginPage: NextPage<ITitle> = ({ title }): JSX.Element => {
  return (
    <Layout
      title={title}
      isNavbar={false}
      isSidebar={false}
      isFullWidth
      bg="white"
    >
      <Login />
    </Layout>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  return middlewareLogin(context, {
    title: 'Login',
  });
}
export default LoginPage;
